import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ExcelInventoryImport_ShellService } from './ExcelInventoryImport.shell.service';
import { ExcelInventoryImport_OperationService } from './ExcelInventoryImport.operation.service';
import { ExcelInventoryImport_DatasourceService } from './ExcelInventoryImport.datasource.index';
import { ExcelInventoryImport_FlowService } from './ExcelInventoryImport.flow.index';
import { ExcelInventoryImport_ReportService } from './ExcelInventoryImport.report.index';
import { ExcelInventoryImport_LocalizationService } from './ExcelInventoryImport.localization.service';
import { ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService } from './ExcelInventoryImport.excel_inventory_import_staging_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ExcelInventoryImport.frontend.types'
import { $frontendTypes as $types} from './ExcelInventoryImport.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ExcelInventoryImport_import_statuses_dd_singleComponent } from './ExcelInventoryImport.import_statuses_dd_single.component'


interface IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity {
  Id?: string, ImportStatus?: string, ImportCreatedDate?: string, ImportCompletedDate?: string, ImportErrorMessage?: string, Owner?: string, Project?: string, Warehouse?: string, Location?: string, LicensePlate?: string, Material?: string, Lot?: string, VendorLot?: string, Vat?: string, Packaging?: string, PackagedAmount?: string, SerialNumber?: string, NetWeight?: string, GrossWeight?: string, WeightUOM?: string, LotStatus?: string, ReasonCode?: string, ManufactureDate?: string, ExpirationDate?: string, ReceiveDate?: string, ContainerTypeName?: string, ContainerTypeWeight?: string, UDF01Name?: string, UDF01Value?: string, UDF01Entity?: string, UDF02Name?: string, UDF02Value?: string, UDF02Entity?: string, UDF03Name?: string, UDF03Value?: string, UDF03Entity?: string, UDF04Name?: string, UDF04Value?: string, UDF04Entity?: string, UDF05Name?: string, UDF05Value?: string, UDF05Entity?: string, LicensePlateStatus?: string}



class ExcelInventoryImport_excel_inventory_import_staging_gridComponentRowModel extends GridRowModel {
  grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent;
  entity: IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: null,
    ImportStatus: null,
    ImportCreatedDate: null,
    ImportCompletedDate: null,
    ImportErrorMessage: null,
    Owner: null,
    Project: null,
    Warehouse: null,
    Location: null,
    LicensePlate: null,
    LicensePlateStatus: null,
    Material: null,
    Lot: null,
    LotStatus: null,
    VendorLot: null,
    Packaging: null,
    PackagedAmount: null,
    SerialNumber: null,
    NetWeight: null,
    GrossWeight: null,
    WeightUOM: null,
    ReasonCode: null,
    ManufactureDate: null,
    ExpirationDate: null,
    ReceiveDate: null,
    ContainerTypeName: null,
    ContainerTypeWeight: null,
    UDF01Entity: null,
    UDF01Name: null,
    UDF01Value: null,
    UDF02Entity: null,
    UDF02Name: null,
    UDF02Value: null,
    UDF03Entity: null,
    UDF03Name: null,
    UDF03Value: null,
    UDF04Entity: null,
    UDF04Name: null,
    UDF04Value: null,
    UDF05Entity: null,
    UDF05Name: null,
    UDF05Value: null,
  }



  constructor(
    grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ExcelInventoryImport_ShellService,
private $datasources: ExcelInventoryImport_DatasourceService,
private $flows: ExcelInventoryImport_FlowService,
private $reports: ExcelInventoryImport_ReportService,
private $localization: ExcelInventoryImport_LocalizationService,
private $operations: ExcelInventoryImport_OperationService,
private $logger: CleanupLoggerService,
private $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportStatus = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportStatus,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportCreatedDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportCreatedDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportCompletedDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportCompletedDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportErrorMessage = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportErrorMessage,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Owner = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Owner,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Location = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LicensePlate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LicensePlate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LicensePlateStatus = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LicensePlateStatus,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Material = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Material,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LotStatus = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LotStatus,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorLot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorLot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PackagedAmount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PackagedAmount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SerialNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SerialNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.NetWeight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.NetWeight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.GrossWeight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.GrossWeight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.WeightUOM = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.WeightUOM,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ReasonCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ReasonCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ManufactureDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ManufactureDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ExpirationDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ExpirationDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ReceiveDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ReceiveDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ContainerTypeName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ContainerTypeName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ContainerTypeWeight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ContainerTypeWeight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF01Entity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF01Entity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF01Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF01Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF01Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF01Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF02Entity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF02Entity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF02Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF02Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF02Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF02Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF03Entity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF03Entity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF03Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF03Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF03Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF03Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF04Entity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF04Entity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF04Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF04Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF04Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF04Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF05Entity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF05Entity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF05Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF05Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF05Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF05Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      import_status:  $grid.filters.import_status.control.value ,
      full_text_search:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.ExcelInventoryImport.ds_inventory_import_staging_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id;
    (this.cells.ImportStatus.displayControl as TextModel).text = $row.entity.ImportStatus;
    (this.cells.ImportCreatedDate.displayControl as TextModel).text = $row.entity.ImportCreatedDate;
    (this.cells.ImportCompletedDate.displayControl as TextModel).text = $row.entity.ImportCompletedDate;
    (this.cells.ImportErrorMessage.displayControl as TextModel).text = $row.entity.ImportErrorMessage;
    (this.cells.Owner.displayControl as TextModel).text = $row.entity.Owner;
    (this.cells.Project.displayControl as TextModel).text = $row.entity.Project;
    (this.cells.Warehouse.displayControl as TextModel).text = $row.entity.Warehouse;
    (this.cells.Location.displayControl as TextModel).text = $row.entity.Location;
    (this.cells.LicensePlate.displayControl as TextModel).text = $row.entity.LicensePlate;
    (this.cells.LicensePlateStatus.displayControl as TextModel).text = $row.entity.LicensePlateStatus;
    (this.cells.Material.displayControl as TextModel).text = $row.entity.Material;
    (this.cells.Lot.displayControl as TextModel).text = $row.entity.Lot;
    (this.cells.LotStatus.displayControl as TextModel).text = $row.entity.LotStatus;
    (this.cells.VendorLot.displayControl as TextModel).text = $row.entity.VendorLot;
    (this.cells.Packaging.displayControl as TextModel).text = $row.entity.Packaging;
    (this.cells.PackagedAmount.displayControl as TextModel).text = $row.entity.PackagedAmount;
    (this.cells.SerialNumber.displayControl as TextModel).text = $row.entity.SerialNumber;
    (this.cells.NetWeight.displayControl as TextModel).text = $row.entity.NetWeight;
    (this.cells.GrossWeight.displayControl as TextModel).text = $row.entity.GrossWeight;
    (this.cells.WeightUOM.displayControl as TextModel).text = $row.entity.WeightUOM;
    (this.cells.ReasonCode.displayControl as TextModel).text = $row.entity.ReasonCode;
    (this.cells.ManufactureDate.displayControl as TextModel).text = $row.entity.ManufactureDate;
    (this.cells.ExpirationDate.displayControl as TextModel).text = $row.entity.ExpirationDate;
    (this.cells.ReceiveDate.displayControl as TextModel).text = $row.entity.ReceiveDate;
    (this.cells.ContainerTypeName.displayControl as TextModel).text = $row.entity.ContainerTypeName;
    (this.cells.ContainerTypeWeight.displayControl as TextModel).text = $row.entity.ContainerTypeWeight;
    (this.cells.UDF01Entity.displayControl as TextModel).text = $row.entity.UDF01Entity;
    (this.cells.UDF01Name.displayControl as TextModel).text = $row.entity.UDF01Name;
    (this.cells.UDF01Value.displayControl as TextModel).text = $row.entity.UDF01Value;
    (this.cells.UDF02Entity.displayControl as TextModel).text = $row.entity.UDF02Entity;
    (this.cells.UDF02Name.displayControl as TextModel).text = $row.entity.UDF02Name;
    (this.cells.UDF02Value.displayControl as TextModel).text = $row.entity.UDF02Value;
    (this.cells.UDF03Entity.displayControl as TextModel).text = $row.entity.UDF03Entity;
    (this.cells.UDF03Name.displayControl as TextModel).text = $row.entity.UDF03Name;
    (this.cells.UDF03Value.displayControl as TextModel).text = $row.entity.UDF03Value;
    (this.cells.UDF04Entity.displayControl as TextModel).text = $row.entity.UDF04Entity;
    (this.cells.UDF04Name.displayControl as TextModel).text = $row.entity.UDF04Name;
    (this.cells.UDF04Value.displayControl as TextModel).text = $row.entity.UDF04Value;
    (this.cells.UDF05Entity.displayControl as TextModel).text = $row.entity.UDF05Entity;
    (this.cells.UDF05Name.displayControl as TextModel).text = $row.entity.UDF05Name;
    (this.cells.UDF05Value.displayControl as TextModel).text = $row.entity.UDF05Value;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      this.isNew = false;
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: ExcelInventoryImport_excel_inventory_import_staging_gridComponentRowModel,
  $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent, 
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/2024/2024
  
  const format = `MM/DD/YYYY, LT`;
  
  if ($utils.isDefined(format)) {
      if ($utils.isDefined($row.entity.ImportCreatedDate)) {
          $row.cells.ImportCreatedDate.displayControl.text = $utils.date.format($row.entity.ImportCreatedDate, format);
      }
      if ($utils.isDefined($row.entity.ImportCompletedDate)) {
          $row.cells.ImportCompletedDate.displayControl.text = $utils.date.format($row.entity.ImportCompletedDate, format);
      }
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ExcelInventoryImport_import_statuses_dd_singleComponent),
  ],
  selector: 'ExcelInventoryImport-excel_inventory_import_staging_grid',
  templateUrl: './ExcelInventoryImport.excel_inventory_import_staging_grid.component.html'
})
export class ExcelInventoryImport_excel_inventory_import_staging_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;



  //#region Variables
  vars: { running?: boolean } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       ImportStatus: new GridHeaderModel(new HeaderStyles(null, null), 'ImportStatus', 'Status', false, false, null, false),       ImportCreatedDate: new GridHeaderModel(new HeaderStyles(null, null), 'ImportCreatedDate', 'Created', false, false, null, false),       ImportCompletedDate: new GridHeaderModel(new HeaderStyles(null, null), 'ImportCompletedDate', 'Completed', false, false, null, false),       ImportErrorMessage: new GridHeaderModel(new HeaderStyles(null, null), 'ImportErrorMessage', 'Message', false, false, null, false),       Owner: new GridHeaderModel(new HeaderStyles(null, null), 'Owner', 'Owner', false, false, null, false),       Project: new GridHeaderModel(new HeaderStyles(null, null), 'Project', 'Project', false, false, null, false),       Warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse', 'Warehouse', false, false, null, false),       Location: new GridHeaderModel(new HeaderStyles(null, null), 'Location', 'Location', false, false, null, false),       LicensePlate: new GridHeaderModel(new HeaderStyles(null, null), 'LicensePlate', 'License plate', false, false, null, false),       LicensePlateStatus: new GridHeaderModel(new HeaderStyles(null, null), 'LicensePlateStatus', 'License plate status', false, false, null, false),       Material: new GridHeaderModel(new HeaderStyles(null, null), 'Material', 'Material', false, false, null, false),       Lot: new GridHeaderModel(new HeaderStyles(null, null), 'Lot', 'Lot', false, false, null, false),       LotStatus: new GridHeaderModel(new HeaderStyles(null, null), 'LotStatus', 'Lot status', false, false, null, false),       VendorLot: new GridHeaderModel(new HeaderStyles(null, null), 'VendorLot', 'Vendor lot', false, false, null, false),       Packaging: new GridHeaderModel(new HeaderStyles(null, null), 'Packaging', 'Packaging', false, false, null, false),       PackagedAmount: new GridHeaderModel(new HeaderStyles(null, null), 'PackagedAmount', 'Packaged amount', false, false, null, false),       SerialNumber: new GridHeaderModel(new HeaderStyles(null, null), 'SerialNumber', 'Serial number', false, false, null, false),       NetWeight: new GridHeaderModel(new HeaderStyles(null, null), 'NetWeight', 'Net weight', false, false, null, false),       GrossWeight: new GridHeaderModel(new HeaderStyles(null, null), 'GrossWeight', 'Gross weight', false, false, null, false),       WeightUOM: new GridHeaderModel(new HeaderStyles(null, null), 'WeightUOM', 'Weight UOM', false, false, null, false),       ReasonCode: new GridHeaderModel(new HeaderStyles(null, null), 'ReasonCode', 'Reason code', false, false, null, false),       ManufactureDate: new GridHeaderModel(new HeaderStyles(null, null), 'ManufactureDate', 'Manufacture date', false, false, null, false),       ExpirationDate: new GridHeaderModel(new HeaderStyles(null, null), 'ExpirationDate', 'Expiration date', false, false, null, false),       ReceiveDate: new GridHeaderModel(new HeaderStyles(null, null), 'ReceiveDate', 'Receive date', false, false, null, false),       ContainerTypeName: new GridHeaderModel(new HeaderStyles(null, null), 'ContainerTypeName', 'Container type name', false, false, null, false),       ContainerTypeWeight: new GridHeaderModel(new HeaderStyles(null, null), 'ContainerTypeWeight', 'Container type weight', false, false, null, false),       UDF01Entity: new GridHeaderModel(new HeaderStyles(null, null), 'UDF01Entity', 'UDF01 entity', false, false, null, false),       UDF01Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF01Name', 'UDF01 name', false, false, null, false),       UDF01Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF01Value', 'UDF01 value', false, false, null, false),       UDF02Entity: new GridHeaderModel(new HeaderStyles(null, null), 'UDF02Entity', 'UDF02 entity', false, false, null, false),       UDF02Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF02Name', 'UDF02 name', false, false, null, false),       UDF02Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF02Value', 'UDF02 value', false, false, null, false),       UDF03Entity: new GridHeaderModel(new HeaderStyles(null, null), 'UDF03Entity', 'UDF03 entity', false, false, null, false),       UDF03Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF03Name', 'UDF03 name', false, false, null, false),       UDF03Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF03Value', 'UDF03 value', false, false, null, false),       UDF04Entity: new GridHeaderModel(new HeaderStyles(null, null), 'UDF04Entity', 'UDF04 entity', false, false, null, false),       UDF04Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF04Name', 'UDF04 name', false, false, null, false),       UDF04Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF04Value', 'UDF04 value', false, false, null, false),       UDF05Entity: new GridHeaderModel(new HeaderStyles(null, null), 'UDF05Entity', 'UDF05 entity', false, false, null, false),       UDF05Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF05Name', 'UDF05 name', false, false, null, false),       UDF05Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF05Value', 'UDF05 value', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ExcelInventoryImport_excel_inventory_import_staging_gridComponentRowModel[] = [];


  topToolbar = {
      run_import: new ToolModel(new ButtonModel('run_import', new ButtonStyles(null, null), false, false, false, 'Run import', 'icon-ic_fluent_play_20_regular', null)
    , false),
      line_count: new ToolModel(new ButtonModel('line_count', new ButtonStyles(null, null), false, false, false, 'Line count', '', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      delete_row: new ToolModel(new ButtonModel('delete_row', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false),
      purge_table: new ToolModel(new ButtonModel('purge_table', new ButtonStyles(['destructive'], null), false, false, false, 'Purge table', 'icon-ic_fluent_delete_lines_20_regular', null)
    , false),
      separator3: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      view_logs: new ToolModel(new ButtonModel('view_logs', new ButtonStyles(null, null), false, false, false, 'Logs', 'icon-ic_fluent_document_bullet_list_20_regular', null)
    , false),
      separator10: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      refresh_grid: new ToolModel(new ButtonModel('refresh_grid', new ButtonStyles(null, null), false, false, false, ' ', 'ms-Icon ms-Icon--Refresh', () => { const $utils = this.$utils; const $grid = this; return 'Refresh'; })
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };

  formGroup: FormGroup = new FormGroup({
    import_status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    validation_only: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  filters = {
    import_status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['import_status'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Import status', false, false),
    validation_only: new FieldModel(new CheckBoxModel(this.formGroup.controls['validation_only'] as DatexFormControl, null, false, false, 'Validation only', null)
, new ControlContainerStyles(null, null), '', false, false),
    ready: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(null, null), '', false, false),
    completed: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(['creation'], null), '', false, false),
    errors: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(['important'], null), '', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ExcelInventoryImport_ShellService,
    private $datasources: ExcelInventoryImport_DatasourceService,
    private $flows: ExcelInventoryImport_FlowService,
    private $reports: ExcelInventoryImport_ReportService,
    private $localization: ExcelInventoryImport_LocalizationService,
    private $operations: ExcelInventoryImport_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Excel inventory import staging';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;

    (this.filters.ready.control as TextModel).text = 'Ready';
    (this.filters.completed.control as TextModel).text = 'Completed';
    (this.filters.errors.control as TextModel).text = 'Error';

    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['validation_only']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_validation_only_change();
      });

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      import_status:  $grid.filters.import_status.control.value ,
      full_text_search:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.ExcelInventoryImport.ds_inventory_import_staging_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ExcelInventoryImport_excel_inventory_import_staging_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: ExcelInventoryImport_excel_inventory_import_staging_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  async addRow(entity?: IExcelInventoryImport_excel_inventory_import_staging_gridComponentEntity) {
    const row = new ExcelInventoryImport_excel_inventory_import_staging_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 10/29/2024
  
  const wb = $event;
  
  //Defining the output to make sure the columns are organized
  let inventory_records: $types.ExcelInventoryImport.InventoryImportRecord[] = [];
  
  let we_have_rows: boolean = false;
  let export_template: boolean = true;
  
  if ($utils.isDefined($grid.rows)) {
      we_have_rows = true;
  }
  
  if (we_have_rows) {
      export_template = (await $shell.ExcelInventoryImport.openConfirmationDialog("Export", "Please select if you want to export the template or the current results of the grid.", "Export template", "Current results"))
  }
  
  if (export_template) {
  
      inventory_records.push({
          Owner: 'String',
          Project: 'String',
          Warehouse: 'String',
          Location: 'String',
          LicensePlate: 'String',
          LicensePlateStatus: 'String',
          Material: 'String',
          Lot: 'String',
          LotStatus: 'Active, Inactive, Damaged, etc.',
          VendorLot: 'String',
          Vat: 'String',
          Packaging: 'EA, CA, PK, etc.',
          PackagedAmount: 'Integer',
          SerialNumber: 'String',
          NetWeight: 'Decimal',
          GrossWeight: 'Decimal',
          WeightUOM: 'lb, kg',
          ReasonCode: 'String',
          ManufactureDate: 'dd/MM/yyyy',
          ExpirationDate: 'dd/MM/yyyy',
          ReceiveDate: 'dd/MM/yyyy',
          ContainerTypeName: 'String',
          ContainerTypeWeight: 'Decimal',
          UDF01Name: 'String',
          UDF01Value: 'String',
          UDF01Entity: 'String',
          UDF02Name: 'String',
          UDF02Value: 'String',
          UDF02Entity: 'String',
          UDF03Name: 'String',
          UDF03Value: 'String',
          UDF03Entity: 'String',
          UDF04Name: 'String',
          UDF04Value: 'String',
          UDF04Entity: 'String',
          UDF05Name: 'String',
          UDF05Value: 'String',
          UDF05Entity: 'String'
      });
  
  } else {
  
      let import_status: string = $grid.filters.import_status.control.value;
      let full_text_search: string = $grid.fullTextSearch;
  
      let skip: number = 0;
      let take: number = 2500;
      let current: number = 1;
  
      while (current > 0) {
  
          let current_payload = (await $flows.ExcelInventoryImport.inventory_import_staging({
              action: "Read",
              import_status: import_status,
              full_text_search: full_text_search,
              skip: skip,
              take: take
          })).payload;
  
          if ($utils.isDefined(current_payload)) {
  
              current = current_payload.length;
  
              for (let current_row of current_payload) {
  
                  if ($utils.isDefined(current_row.ImportCreatedDate)) {
                      current_row.ImportCreatedDate = $utils.date.format(current_row.ImportCreatedDate, `MM/DD/YYYY, LT`);
                  }
                  if ($utils.isDefined(current_row.ImportCompletedDate)) {
                      current_row.ImportCompletedDate = $utils.date.format(current_row.ImportCompletedDate, `MM/DD/YYYY, LT`);
                  }
              }
  
              inventory_records.push(...current_payload);
  
              if (current < take) {
                  current = 0
              } else {
                  skip = skip + take;
              }
          } else {
              current = 0;
          }
      }
  }
  
  if ($utils.isDefined(inventory_records)) {
  
      const ws = $utils.excel.json_to_sheet(inventory_records);
      $utils.excel.book_append_sheet(wb, ws, 'InventoryImportStaging');
  }
  }
  on_excel_import(event = null) {
    return this.on_excel_importInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_importInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 10/29/2024
  
  const wb = $event;
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  
  $grid.topToolbar.line_count.hidden = false;
  $grid.topToolbar.line_count.control.icon = "icon datex-default-spinner";
  $grid.topToolbar.line_count.control.label = 'Extracting data...';
  
  const Inventory: $types.ExcelInventoryImport.InventoryImportRecord[] = $utils.excel.sheet_to_json<{
      Owner: string,
      Project: string,
      Warehouse: string,
      Location: string,
      LicensePlate: string,
      LicensePlateStatus: string,
      Material: string,
      Lot: string,
      LotStatus: string,
      VendorLot: string,
      Vat: string,
      Packaging: string,
      PackagedAmount: string,
      SerialNumber: string,
      NetWeight: string,
      GrossWeight: string,
      WeightUOM: string,
      ReasonCode: string,
      ManufactureDate: string,
      ExpirationDate: string,
      ReceiveDate: string,
      ContainerTypeName: string,
      ContainerTypeWeight: string,
      UDF01Name: string,
      UDF01Value: string,
      UDF01Entity: string,
      UDF02Name: string,
      UDF02Value: string,
      UDF02Entity: string,
      UDF03Name: string,
      UDF03Value: string,
      UDF03Entity: string,
      UDF04Name: string,
      UDF04Value: string,
      UDF04Entity: string,
      UDF05Name: string,
      UDF05Value: string,
      UDF05Entity: string
  }>(ws);
  
  let input_payload: $types.ExcelInventoryImport.InventoryImportRecord[] = [];
  let input_errors: { LicensePlate: string, ErrorMessage: string }[] = [];
  
  $flows.Utilities.logs_write({
      input: [{
          level: 0,
          process_name: 'excel_inventory_import_staging_grid',
          notes: JSON.stringify({ Inventory: Inventory })
      }],
      criteria: { application_name: "ExcelInventoryImport" }
  })
  
  for (let Item of Inventory) {
  
      try {
  
          let CleanRecord = clean_record({ ...Item });
  
          if ($utils.isDefined(CleanRecord)) {
              input_payload.push(CleanRecord)
          }
  
      } catch (error) {
          input_errors.push({ LicensePlate: Item.LicensePlate, ErrorMessage: get_error(error) });
      }
  }
  
  if (input_errors.length > 0) {
      await $shell.ExcelInventoryImport.openErrorDialog("Error processing some rows", input_errors.map(i => `${i.LicensePlate}: ${i.ErrorMessage}`).join(". "))
  }
  
  let count: number = input_payload?.length ?? 0;
  
  if (count === 0) {
  
      await $shell.ExcelInventoryImport.openToaster(
          "Error reading data",
          "No records were loaded",
          EToasterType.Error,
          { closeButton: true, timeOut: 5000, positionClass: EToasterPosition.bottomRight }
      );
  
  } else {
  
      $grid.topToolbar.line_count.control.label = 'Staging data...';
  
      $flows.Utilities.logs_write({
          input: [{
              level: 0,
              process_name: 'excel_inventory_import_staging_grid',
              notes: JSON.stringify({ input_payload: input_payload })
          }],
          criteria: { application_name: "ExcelInventoryImport" }
      })
  
      let write_to_staging = (await $flows.ExcelInventoryImport.inventory_import_staging({
          action: "Write",
          payload: input_payload
      }));
  
      if (!write_to_staging.success) {
  
          await $shell.ExcelInventoryImport.openErrorDialog("Error staging data", write_to_staging.messages.join(""));
      }
  }
  
  $grid.topToolbar.line_count.control.icon = null;
  $grid.topToolbar.line_count.control.label = 'Ready for import';
  $grid.filters.import_status.control.value = 'Ready';
  
  await $grid.refresh();
  
  function clean_record(candidate: $types.ExcelInventoryImport.InventoryImportRecord) {
  
      let output: typeof candidate = {};
  
      Object.keys(candidate).map(key => {
  
          //Ignore the info columns
          if (["Id", "ImportStatus", "ImportCreatedDate", "ImportCompletedDate", "ImportErrorMessage"].indexOf(key) === -1) {
  
              //Make sure we have data
              if ($utils.isDefined(candidate[key])) {
  
                  if (key.toUpperCase().includes('DATE')) {
  
                      //Ignore the date from the template
                      if (candidate[key] != 'dd/MM/yyyy') {
  
                          //Convert the date from excel
                          output[key] = check_excel_date(candidate[key])
                      }
                  } else {
                      //Make sure the data is a string
                      output[key] = validate_string_value(candidate[key])
                  }
              }
          }
      })
  
      return output;
  }
  
  function get_error(error: any) {
  
      let targetError = error;
      while ($utils.isDefined(targetError?.error)) { targetError = targetError.error }
      if (!$utils.isDefined(targetError?.message)) { targetError = { "message": `Uncaught exception. ${JSON.stringify(targetError)}` } }
  
      return targetError.message;
  }
  
  function validate_string_value(candidate: any) {
      let output: string;
      if ($utils.isDefined(candidate)) {
          if (typeof candidate === "number") {
              output = candidate.toString();
          } else {
              output = candidate;
          }
      }
      return output;
  }
  
  function check_excel_date(dateField: any): any {
  
      if (!isNaN(Number(dateField))) {
          return $utils.date.format($utils.date.add(Number(dateField) - 2, "day", "01/01/1900"), `MM/DD/YYYY, LT`)
      } else {
          return dateField;
      }
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/17/2024
  
  $grid.topToolbar.delete_row.control.readOnly = true;
  $grid.topToolbar.line_count.hidden = true;
  $grid.headers.Id.hidden = true;
  $grid.vars.running = false;
  $grid.canAdd = false;
  $grid.canEdit = false;
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 10/07/2024
  
  let errors = (await $flows.ExcelInventoryImport.inventory_import_staging({
      action: "Count",
      import_status: "Error"
  })).count;
  
  if ($utils.isDefined(errors)) {
      $grid.filters.errors.hidden = false;
      $grid.filters.errors.control.text = `Errors ${errors}`;
  } else {
      $grid.filters.errors.hidden = true;
  }
  
  let ready = (await $flows.ExcelInventoryImport.inventory_import_staging({
      action: "Count",
      import_status: "Ready"
  })).count;
  
  if ($utils.isDefined(ready)) {
      $grid.filters.ready.hidden = false;
      $grid.filters.ready.control.text = `Ready ${ready}`;
  } else {
      $grid.filters.ready.hidden = true;
  }
  
  let completed = (await $flows.ExcelInventoryImport.inventory_import_staging({
      action: "Count",
      import_status: "Completed"
  })).count;
  
  if ($utils.isDefined(completed)) {
      $grid.filters.completed.hidden = false;
      $grid.filters.completed.control.text = `Completed ${completed}`;
  } else {
      $grid.filters.completed.hidden = true;
  }
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/17/2024
  
  const selected_rows = $grid.selectedRows;
  let errors: { reference: string, id: string, errorMessages: string[] }[] = [];
  let deleted_records: string[] = [];
  
  if (selected_rows.length === 0) {
      $shell.ExcelInventoryImport.openErrorDialog('Delete error', 'No records were selected');
      return;
  }
  
  const confirm_purge = (await $shell.ExcelInventoryImport.openConfirmationDialog(`Confirm delete`, `Do you want to delete ${selected_rows.length} records?`, `Delete`, `Cancel`));
  
  if (confirm_purge) {
  
      for (const row of selected_rows) {
  
          let current_error: string;
          let success = false;
          current_error = null;
  
          try {
  
              let entity = row.entity
  
              await message_delete({
                  Id: entity.Id
              });
  
              success = true;
  
          } catch (error) {
  
              let target_error = error;
  
              if (typeof target_error === "string") {
                  target_error = { message: target_error }
              } else {
                  while ($utils.isDefined(target_error.error)) {
                      target_error = target_error.error;
                  }
              }
  
              if (!$utils.isDefined(target_error.message)) {
                  target_error = { message: `Uncaught exception. ${JSON.stringify(target_error)}` }
              }
  
              current_error = target_error.message;
          }
  
          if (success) {
              deleted_records.push(row.entity.Id.toString())
          } else {
              errors.push({
                  reference: row.entity.LicensePlate ?? row.entity.Location, id: row.entity.Id, errorMessages: [current_error]
              });
          }
      }
  
      if ($utils.isDefined(errors)) {
          await $shell.ExcelInventoryImport.openErrorDialog(
              `Delete record${selected_rows.length > 1 ? 's' : ''}`,
              deleted_records.length > 0 ? `Record${selected_rows.length > 1 ? 's' : ''} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: deleted_records })).formattedValue} successfully deleted.` : `No records were deleted.`,
              null,
              `Errors deleting record${selected_rows.length > 1 ? 's' : ''}`,
              errors.map(error => ({ detail: error.errorMessages[0], message: `Id: ${error.id} Reference: ${error.reference}` })))
      }
  }
  
  $grid.refresh();
  
  
  
  /**************************************
   * FUNCTIONS
  ***************************************/
  async function message_delete(input: $types.ExcelInventoryImport.InventoryImportRecord) {
      await $flows.ExcelInventoryImport.inventory_import_staging({ action: "Delete", payload: [input] });
  }
  }
  on_purge_data(event = null) {
    return this.on_purge_dataInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_purge_dataInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/17/2024
  
  let confirm_purge = (await $shell.ExcelInventoryImport.openConfirmationDialog("Confirm purge", "Are you sure you want to purge all the current data in staging?", "Yes", "No"))
  
  if (confirm_purge) {
  
      $grid.topToolbar.line_count.hidden = false;
      $grid.topToolbar.line_count.control.label = 'Purging old data...';
  
      let purge_staging = (await $flows.ExcelInventoryImport.inventory_import_staging({
          action: "Purge"
      }));
  
      if (!purge_staging.success) {
  
          await $shell.ExcelInventoryImport.openErrorDialog("Error purging staging table", purge_staging.messages.join(""));
  
      }
  
      $grid.topToolbar.line_count.control.icon = null;
      $grid.topToolbar.line_count.control.label = '';
      $grid.topToolbar.line_count.hidden = true;
  
      $grid.refresh();
  }
  }
  on_refresh_clicked(event = null) {
    return this.on_refresh_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refresh_clickedInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/13/2024
  
  $grid.refresh();
  $grid.vars.running = false;
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  const selectedRowsCount = $grid.selectedRows.length;
  
  $grid.topToolbar.delete_row.control.readOnly = (selectedRowsCount > 0 ? false : true);
  
  if (selectedRowsCount === 1) {
      $grid.topToolbar.delete_row.control.label = "Delete row";
  } else if (selectedRowsCount > 1) {
      $grid.topToolbar.delete_row.control.label = "Delete rows";
  } else {
      $grid.topToolbar.delete_row.control.label = "Delete row";
  }
  }
  on_run_clicked(event = null) {
    return this.on_run_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_run_clickedInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 10/07/2024
  
  if (!$grid.vars.running) {
  
      $grid.vars.running = true;
      $grid.topToolbar.line_count.hidden = false;
      $grid.topToolbar.line_count.control.icon = "icon datex-default-spinner";
      $grid.topToolbar.line_count.control.label = 'Submitting data...';
  
      try {
  
          let run_import = (await $flows.ExcelInventoryImport.inventory_import_staging_main({ validation_only: $grid.filters.validation_only.control.value }))
  
          if (run_import.success) {
  
              if ($grid.filters.validation_only.control.value ?? false) {
                  $grid.topToolbar.line_count.control.label = `Validation completed (${run_import.time} sec)`;
              } else {
                  $grid.topToolbar.line_count.control.label = `Import completed (${run_import.time} sec)`;
              }
          } else {
  
              $grid.topToolbar.line_count.control.label = 'Error';
              await $shell.ExcelInventoryImport.openErrorDialog("Error", run_import?.messages?.join(" "))
          }
  
      } catch (error) {
          $grid.topToolbar.line_count.control.label = 'Error';
  
          let targetError = error;
          while ($utils.isDefined(targetError?.error)) { targetError = targetError.error }
          if (!$utils.isDefined(targetError?.message)) { targetError = { "message": `Uncaught exception ${JSON.stringify(targetError)}` } }
  
          await $shell.ExcelInventoryImport.openErrorDialog("Error", targetError?.message)
      }
  
      $grid.topToolbar.line_count.control.icon = null;
      $grid.vars.running = false;
  }
  
  $grid.refresh();
  }
  on_validation_only_change(event = null) {
    return this.on_validation_only_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_validation_only_changeInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  if ($grid.filters.validation_only.control.value ?? false) {
      $grid.topToolbar.run_import.control.label = 'Run validation'
  } else {
      $grid.topToolbar.run_import.control.label = 'Run import'
  }
  }
  on_view_logs(event = null) {
    return this.on_view_logsInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_view_logsInternal(
    $grid: ExcelInventoryImport_excel_inventory_import_staging_gridComponent,
  
    $shell: ExcelInventoryImport_ShellService,
    $datasources: ExcelInventoryImport_DatasourceService,
    $flows: ExcelInventoryImport_FlowService,
    $reports: ExcelInventoryImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelInventoryImport_OperationService,
    $utils: UtilsService,
    $context: ExcelInventoryImport_excel_inventory_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelInventoryImport_LocalizationService,
    $event: any
  ) {
  await $shell.Utilities.openlogs_gridDialog({ application_name: 'ExcelInventoryImport' }, 'modal', EModalSize.Xlarge)
  }
  //#endregion private flows

  async $importExcel(fileInput: HTMLInputElement) {
    if(fileInput.files?.length !== 1) {
      throw new Error('Cannot import multiple files');
    }
    const file = fileInput.files[0];
    if(file.size > 15 * 1000 * 1000) {
      throw new Error('Cannot import a file with size greater than 15MB');
    }
    const reader: FileReader = new FileReader();
    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const ab: ArrayBuffer = e.target?.result as ArrayBuffer;
      const wb: WorkBook = readExcelFile(ab);
      await this.on_excel_import(wb);
    };
    reader.readAsArrayBuffer(file);
    fileInput.value = '';
  }

  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'ExcelInventoryImport_excel_inventory_import_staging_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
